<template>
  <div id="container">
    <HeaderBar />
    <div id="main">
      <BannerBar label="关于我们" />
      <CompanyIntroContent />
      <TeamIntroContent />
    </div>
    <FooterBar />
    <scroll-back></scroll-back>
  </div>
</template>

<script>
import HeaderBar from "@/components/HeaderBar"
import FooterBar from "@/components/FooterBar"
import BannerBar from "@/components/BannerBar"
import CompanyIntroContent from "./components/CompanyIntroContent"
import TeamIntroContent from "./components/TeamIntroContent"
export default {
  metaInfo: {
    title: "温州星原统计服务有限公司 - 关于我们",
    meta: [{
      name: "keywords",
      content: "温州，星原，统计服务，统计代理，文化创意"
    },
    {
      name: "author",
      content: "温州星原统计服务有限公司"
    },
    {
      name: "description",
      content: "近几年，随着统计数据逐步走进公众视野，统计工作地位不断提升，但由于基层统计基础薄弱，统计服务对象购买社会统计服务成为重要趋势，统计服务公司作为新兴业态已得到各级领导高度支持和认可。"
    }
    ]
  },
  name: "AboutUs",
  components: {
    HeaderBar,
    FooterBar,
    BannerBar,
    CompanyIntroContent,
    TeamIntroContent
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/variables.less";

#main {
  padding-bottom: 116px;
}
</style>